/*
* Galgo Theme Customizations
*/

(function() {
  const osStyleId = "os-tab-collections-mobile-image-lock";

  function injectTabCollectionsMobileStyle() {
    if (document.getElementById(osStyleId)) return;

    const style = document.createElement("style");
    style.id = osStyleId;
    style.textContent = `
      @media only screen and (max-width: 749px) {
        .index-tab-collections hover-images,
        .index-products hover-images {
          display: none !important;
        }

        .index-tab-collections .product-item__image .product-item__bg,
        .index-products .product-item__image .product-item__bg {
          opacity: 1 !important;
          visibility: visible !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", injectTabCollectionsMobileStyle, { once: true });
  } else {
    injectTabCollectionsMobileStyle();
  }
})();
